import React from "react";
import AppleBadge from "../../../../assets/img/app-app-store.inline.svg";
import GoogleBadge from "../../../../assets/img/app-google-play.inline.svg";

const EntryBadgesV2 = (props) => {

  return (
    !props.hideBadge && (
      <div
        className={`kuda-app--badges flex align-center ${typeof props.className !== "undefined" ? props.className : ""
          }`}
      >
        <div
          className="ios_app_store single-badge">
           <a
            href={
              props.isAmbassador
                ? props.ambassadorUrl :
                "https://kuda.onelink.me/abUI/344e3dde/"}
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="Get Kuda app on Appstore"
          >
            <AppleBadge />
          </a></div>
        <div
          className="google_play_store single-badge">
          <a
            href={
              props.isGoogleAmbassador
                ? props.googleAmbassadorUrl :
                "https://kuda.onelink.me/abUI/344e3dde/"}
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="Get Kuda app on Google Play"
          >
            <GoogleBadge />
          </a>
        </div>
      </div>
    )
  );
};

export default EntryBadgesV2;
